<template>
  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M-3.93402e-07 9L4 13L8 9L5 9C5 5.141 8.14 2 12 2C12.88 2 13.7201 2.17075 14.4961 2.46875L16.0098 0.953124C14.8008 0.348125 13.442 -5.87568e-07 12 -5.24537e-07C7.038 -3.07641e-07 3 4.037 3 9L-3.93402e-07 9ZM7.99023 17.0469C9.19923 17.6519 10.558 18 12 18C16.962 18 21 13.963 21 9L24 9L20 5L16 9L19 9C19 12.859 15.86 16 12 16C11.12 16 10.2799 15.8292 9.50391 15.5312L7.99023 17.0469Z" fill="#000" />
  </svg>
</template>
